import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-6 bg-white rounded-lg shadow-md" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4 p-3 bg-blue-100 text-blue-700 rounded-md"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-4 p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_4 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_5 = { class: "p-4 bg-green-100 text-green-700 rounded-md mb-4" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 3,
  class: "mb-6"
}
const _hoisted_10 = { class: "flex space-x-4" }
const _hoisted_11 = {
  key: 4,
  class: "mt-6 p-4 border border-gray-200 rounded-md"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 5,
  class: "mt-6 p-4 border border-gray-200 rounded-md"
}
const _hoisted_14 = {
  key: 0,
  class: "p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "mt-6" }
const _hoisted_17 = { class: "flex flex-wrap gap-2 mb-4" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_29 = {
  key: 0,
  class: "p-4 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_30 = { class: "whitespace-pre-wrap" }
const _hoisted_31 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_32 = {
  key: 0,
  class: "mt-4 border-t border-red-200 pt-4"
}
const _hoisted_33 = { class: "list-disc pl-5 mb-4" }
const _hoisted_34 = {
  key: 1,
  class: "mt-4 whitespace-pre-wrap bg-red-50 p-2 rounded"
}
const _hoisted_35 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_36 = {
  key: 0,
  class: "p-4 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_37 = { class: "whitespace-pre-wrap" }
const _hoisted_38 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_39 = {
  key: 0,
  class: "mt-4 whitespace-pre-wrap bg-red-50 p-2 rounded"
}
const _hoisted_40 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_41 = {
  key: 0,
  class: "p-4 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_42 = { class: "whitespace-pre-wrap mt-2" }
const _hoisted_43 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_44 = {
  key: 0,
  class: "mt-4 whitespace-pre-wrap bg-red-50 p-2 rounded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[38] || (_cache[38] = _createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Supabase Integration Test", -1)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Error: " + _toDisplayString(_ctx.error.message), 1))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "font-bold" }, "✅ Authenticated", -1)),
            _createElementVNode("p", null, "User ID: " + _toDisplayString(_ctx.user?.id), 1),
            _createElementVNode("p", null, "Email: " + _toDisplayString(_ctx.user?.email), 1),
            _createElementVNode("p", null, "Name: " + _toDisplayString(_ctx.profile?.name || 'Not set'), 1),
            _createElementVNode("p", null, "Username: " + _toDisplayString(_ctx.profile?.username || 'Not set'), 1),
            _createElementVNode("p", null, [
              _cache[15] || (_cache[15] = _createTextVNode("Business Role: ")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.profile?.business_role ? _ctx.formatBusinessRole(_ctx.profile.business_role as BusinessRole) : 'Not set'), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[16] || (_cache[16] = _createTextVNode("System Role: ")),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.profile?.system_role ? _ctx.SystemRole[_ctx.profile.system_role] : 'Not set'), 1)
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
            class: "px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors",
            disabled: _ctx.loading
          }, " Logout ", 8, _hoisted_8)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "p-4 bg-yellow-100 text-yellow-700 rounded-md mb-4" }, [
            _createElementVNode("p", { class: "font-bold" }, "⚠️ Not Authenticated"),
            _createElementVNode("p", null, "Please login or register to test Supabase authentication.")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showLoginForm = true; _ctx.showRegisterForm = false}),
              class: "px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
            }, " Show Login Form "),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showRegisterForm = true; _ctx.showLoginForm = false}),
              class: "px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors"
            }, " Show Register Form ")
          ])
        ])),
    (!_ctx.isAuthenticated && _ctx.showLoginForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "Login", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"])),
            class: "space-y-4"
          }, [
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                for: "login-email",
                class: "block text-sm font-medium mb-1"
              }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "login-email",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginForm.email) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.loginForm.email]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[20] || (_cache[20] = _createElementVNode("label", {
                for: "login-password",
                class: "block text-sm font-medium mb-1"
              }, "Password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "login-password",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.loginForm.password]
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors",
              disabled: _ctx.loading
            }, " Login ", 8, _hoisted_12)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAuthenticated && _ctx.showRegisterForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "Register", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"])),
            class: "space-y-4"
          }, [
            _createElementVNode("div", null, [
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                for: "register-fullname",
                class: "block text-sm font-medium mb-1"
              }, "Full Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "register-fullname",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerForm.fullname) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.registerForm.fullname]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "register-email",
                class: "block text-sm font-medium mb-1"
              }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "register-email",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerForm.email) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.registerForm.email]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "register-username",
                class: "block text-sm font-medium mb-1"
              }, "Username", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "register-username",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registerForm.username) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.registerForm.username]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[25] || (_cache[25] = _createElementVNode("label", {
                for: "register-password",
                class: "block text-sm font-medium mb-1"
              }, "Password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "register-password",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registerForm.password) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.registerForm.password]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[26] || (_cache[26] = _createElementVNode("label", {
                for: "register-confirm-password",
                class: "block text-sm font-medium mb-1"
              }, "Confirm Password", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "register-confirm-password",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registerForm.confirmPassword) = $event)),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.registerForm.confirmPassword]
              ])
            ]),
            (_ctx.passwordMismatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Passwords do not match "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              class: "w-full px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors",
              disabled: _ctx.loading || _ctx.passwordMismatch
            }, " Register ", 8, _hoisted_15)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-xl font-bold mb-2" }, "Database Test", -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.testDatabaseConnection && _ctx.testDatabaseConnection(...args))),
          class: "px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors",
          disabled: _ctx.dbLoading
        }, [
          (_ctx.dbLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Testing..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, "Test Database Connection"))
        ], 8, _hoisted_18),
        _createElementVNode("button", {
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.checkSupabaseConfig && _ctx.checkSupabaseConfig(...args))),
          class: "px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors",
          disabled: _ctx.configCheckLoading
        }, [
          (_ctx.configCheckLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Checking..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_23, "Check Supabase Config"))
        ], 8, _hoisted_21)
      ]),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.testBusinessRoleUpdate && _ctx.testBusinessRoleUpdate(...args))),
              class: "px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition-colors",
              disabled: _ctx.businessRoleUpdateLoading
            }, [
              (_ctx.businessRoleUpdateLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Updating..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_27, "Test Business Role Update"))
            ], 8, _hoisted_25)
          ]))
        : _createCommentVNode("", true),
      (_ctx.dbTestResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_ctx.dbTestResult.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "font-bold" }, "Database Connection Successful!", -1)),
                  _createElementVNode("pre", _hoisted_30, _toDisplayString(JSON.stringify(_ctx.dbTestResult.data, null, 2)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _cache[32] || (_cache[32] = _createElementVNode("h4", { class: "font-bold" }, "Database Connection Error", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.dbTestResult.message), 1),
                  (_ctx.dbTestResult.error && _ctx.dbTestResult.error.code === '42P01')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _cache[29] || (_cache[29] = _createElementVNode("h5", { class: "font-bold" }, "Missing Table Error", -1)),
                        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "mb-2" }, "The required database tables have not been created yet. Please create the following tables in your Supabase instance:", -1)),
                        _createElementVNode("ul", _hoisted_33, [
                          _createElementVNode("li", null, _toDisplayString(_ctx.DatabaseTable.PROFILES), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.DatabaseTable.TEMPLATES), 1),
                          _createElementVNode("li", null, _toDisplayString(_ctx.DatabaseTable.FORECASTING_PROCESS), 1)
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("p", null, [
                          _createTextVNode("You can find the SQL scripts to create these tables in the "),
                          _createElementVNode("code", null, "SUPABASE_INTEGRATION.md"),
                          _createTextVNode(" file.")
                        ], -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.dbTestResult.error)
                    ? (_openBlock(), _createElementBlock("pre", _hoisted_34, _toDisplayString(JSON.stringify(_ctx.dbTestResult.error, null, 2)), 1))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.configCheckResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (_ctx.configCheckResult.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "font-bold" }, "Supabase Configuration Check Successful!", -1)),
                  _createElementVNode("pre", _hoisted_37, _toDisplayString(JSON.stringify(_ctx.configCheckResult.data, null, 2)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "font-bold" }, "Supabase Configuration Check Error", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.configCheckResult.message), 1),
                  (_ctx.configCheckResult.error)
                    ? (_openBlock(), _createElementBlock("pre", _hoisted_39, _toDisplayString(JSON.stringify(_ctx.configCheckResult.error, null, 2)), 1))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.businessRoleUpdateResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            (_ctx.businessRoleUpdateResult.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "font-bold" }, "Business Role Update Successful!", -1)),
                  _createElementVNode("p", null, "Previous role: " + _toDisplayString(_ctx.formatBusinessRole(_ctx.businessRoleUpdateResult.previousRole as BusinessRole)), 1),
                  _createElementVNode("p", null, "New role: " + _toDisplayString(_ctx.formatBusinessRole(_ctx.businessRoleUpdateResult.newRole as BusinessRole)), 1),
                  _createElementVNode("pre", _hoisted_42, _toDisplayString(JSON.stringify(_ctx.businessRoleUpdateResult.data, null, 2)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "font-bold" }, "Business Role Update Error", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.businessRoleUpdateResult.message), 1),
                  (_ctx.businessRoleUpdateResult.error)
                    ? (_openBlock(), _createElementBlock("pre", _hoisted_44, _toDisplayString(JSON.stringify(_ctx.businessRoleUpdateResult.error, null, 2)), 1))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}